import { Permissions } from "@api/apiClient";
import useAppStore from "@hooks/useAppStore";
import useUserPermissionStore from "@hooks/useUserPermissionStore";
import i18n from "@i18n/i18n";
import { Grid } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { useGridApiRef } from "@mui/x-data-grid-premium";
import { observer } from "mobx-react";
import { useEffect, useState } from "react";
import AddScenarioDialog from "./AddScenarioDialog";
import ScenariosGrid from "./ScenariosGrid";

const ScenariosTab = observer(() => {
  const appStore = useAppStore();
  const upStore = useUserPermissionStore();
  const [openAddScenarioDialog, setOpenAddScenarioDialog] = useState(false);
  const scenariosGridApiRef = useGridApiRef();

  const handleClickOpen = () => {
    setOpenAddScenarioDialog(true);
  };

  useEffect(() => {
    const go = async () => {
      await appStore.selectionManager.setMode("SingleScenario");
    };
    go();
  }, []);



  return (
    <>
      <Box mt={1} sx={{ display: "flex", flexDirection: "column", gap: 1, minHeight: "200px", width: "100%" }}>
        {/*<ScenarioGrid data={scenarios} selectedId={(v: any) => handleRemoveScenario(v)} />*/}
        <ScenariosGrid apiRef={scenariosGridApiRef} />
        <Grid container spacing={2} sx={{ justifyContent: "end" }}>
          <Grid>
            <Button onClick={handleClickOpen} variant="contained" disabled={!upStore.hasPermission(Permissions.App_Project_Scenario_Create)}>
              {i18n.t("scenarios-tab.add-scenario-button.title")}
            </Button>
          </Grid>
          {/*<Grid>*/}
          {/*  <Button disabled={!selected} onClick={handleCloseOpen} variant="outlined">*/}
          {/*    Remove Scenario*/}
          {/*  </Button>*/}
          {/*</Grid>*/}
        </Grid>
      </Box>
      {openAddScenarioDialog && (
        <AddScenarioDialog
          open={openAddScenarioDialog}
          onClose={() => setOpenAddScenarioDialog(false)}
        />
      )}
    </>
  );
});

export default ScenariosTab;
